import flatpickr from "flatpickr";
import { Estonian } from "flatpickr/dist/l10n/et";
// import { format } from "date-fns";

export default function initBooking() {

  const isPresent = document.querySelector(".booking-form");
  if (!isPresent) {
    return;
  }

  function setDates() {
    function initDatepicker() {
      const startDateTarget = document.querySelector("[data-checkin]");
      const endDateTarget = document.querySelector("[data-checkout]");

      function updateDates(selectedDates) {
        if (selectedDates.length === 2) {
          const startDate = selectedDates[0];
          const endDate = selectedDates[1];

          const formattedStartMonth = (startDate.getMonth() + 1).toString().padStart(2, '0'); // Add leading zeros to the month
          const formattedEndMonth = (endDate.getMonth() + 1).toString().padStart(2, '0'); // Add leading zeros to the month

          const formattedStartDay = startDate.getDate().toString().padStart(2, '0'); // Add leading zeros to the day
          const formattedEndDay = endDate.getDate().toString().padStart(2, '0'); // Add leading zeros to the day


          const startDateString = `${startDate.getFullYear()}-${
            formattedStartMonth
          }-${formattedStartDay}`;
          const endDateString = `${endDate.getFullYear()}-${
            formattedEndMonth
          }-${formattedEndDay}`;
          startDateTarget.dataset.checkin = startDateString;
          endDateTarget.dataset.checkout = endDateString;
        }
      }

      const fp = flatpickr("[data-datepicker]", {
        mode: "range",
        // showMonths: 2,
        static: window.innerWidth < 768 ? true : false,
        showMonths: window.innerWidth < 768 ? 1 : 2,
        minDate: "today",
        defaultDate: [new Date().fp_incr(1), new Date().fp_incr(3)],
        // dateFormat: "Y-j-n",
        locale: Estonian,
        onChange(selectedDates) {
          updateDates(selectedDates);
        },
        onReady(selectedDates) {
          updateDates(selectedDates);
        },
      });

      window.addEventListener('resize', function() {
        fp.set('static', window.innerWidth < 768 ? true : false);
        fp.set('showMonths', window.innerWidth < 768 ? 1 : 2);
      });
    }

    initDatepicker();
  }

  setDates();

  function init() {
    // function getHotel() {
    //   const hotel = document.querySelector("select[data-hotel]");
    //   const selectedHotel = hotel.value;
    //   console.log(`?client=${selectedHotel}`);

    //   const hotelTarget = document.querySelector("[data-url-client]");
    //   hotelTarget.dataset.urlClient = `?client=${selectedHotel}`;
    // }

    function getLanguage() {
      const currentLanguage = document.documentElement.lang;
      console.log(`&language=${currentLanguage}`);

      const languageTarget = document.querySelector("[data-url-language]");
      languageTarget.dataset.urlLanguage = `&language=${currentLanguage}`;
    }

    function getDates() {
      const checkin = document.querySelector("[data-checkin]");
      const checkout = document.querySelector("[data-checkout]");
      const checkinDate = checkin.dataset.checkin;
      const checkoutDate = checkout.dataset.checkout;
      console.log(`&checkin=${checkinDate}`);
      console.log(`&checkout=${checkoutDate}`);

      const checkinTarget = document.querySelector("[data-url-checkin]");
      checkinTarget.dataset.urlCheckin = `&checkin=${checkinDate}`;
      const checkoutTarget = document.querySelector("[data-url-checkout]");
      checkoutTarget.dataset.urlCheckout = `&checkout=${checkoutDate}`;
    }

    function getRoomsCount() {
      const rooms = document.querySelector("select[data-rooms-no]");
      const roomsNo = rooms.value;
      console.log(`&rooms=${roomsNo}`);

      const roomsTarget = document.querySelector("[data-url-rooms]");
      roomsTarget.dataset.urlRooms = `&rooms=${roomsNo}`;
    }

    function combineAdults() {
      const dataAdultElements = document.querySelectorAll("[data-adults]");

      // Loop through the "data-room" elements and add their values to the final string
      let combinedData = "";
      dataAdultElements.forEach((element) => {
        if (element.classList.contains("is-active")) {
          if (element.value) {
            combinedData += `${element.value},`;
          }
        }
      });

      // Remove the trailing comma if there is one
      if (combinedData.endsWith(",")) {
        combinedData = combinedData.slice(0, -1);
      }

      // Set the "data-final" attribute of the specified button to the combined string
      // const finalButton = document.querySelector("#final-button");
      // finalButton.dataset.final = combinedData;

      console.log(`&adults=${combinedData}`);

      const adultsTarget = document.querySelector("[data-url-adults]");
      adultsTarget.dataset.urlAdults = `&adults=${combinedData}`;
    }

    function combineChildren() {
      const dataChildrenElements = document.querySelectorAll("[data-children]");

      // Loop through the "data-room" elements and add their values to the final string
      let combinedDataChildren = "";
      dataChildrenElements.forEach((element) => {
        if (element.classList.contains("is-active")) {
          if (element.value) {
            combinedDataChildren += `${element.value},`;
          }
        }
      });

      // Remove the trailing comma if there is one
      if (combinedDataChildren.endsWith(",")) {
        combinedDataChildren = combinedDataChildren.slice(0, -1);
      }

      // Set the "data-final" attribute of the specified button to the combined string
      // const finalButton = document.querySelector("#final-button");
      // finalButton.dataset.final = combinedData;

      console.log(`&children=${combinedDataChildren}`);

      const childrenTarget = document.querySelector("[data-url-children]");
      childrenTarget.dataset.urlChildren = `&children=${combinedDataChildren}`;
    }

    function getPromocode() {
      const promocode = document.querySelector("input[data-promocode]");
      const promocodeValue = promocode.value;

      if (promocodeValue) {
        console.log(`&code=${promocodeValue}`);

        const codeTarget = document.querySelector("[data-url-code]");
        codeTarget.dataset.urlCode = `&code=${promocodeValue}`;
      }
    }

    // getHotel();
    getLanguage();
    getDates();
    getRoomsCount();
    combineAdults();
    combineChildren();
    getPromocode();
  }

  // ROOMS CHANGE FUNCTION STARTS
  function changeRoomsRows() {
    const selectElement = document.querySelector("select[data-rooms-no]");

    function initChange() {
      const selectedValue = selectElement.value;

      const roomOne = document.querySelector("[data-room-one]");
      const roomOneAdults = roomOne.querySelector("[data-adults]");
      const roomOneChildren = roomOne.querySelector("[data-children]");

      const roomTwo = document.querySelector("[data-room-two]");
      const roomTwoAdults = roomTwo.querySelector("[data-adults]");
      const roomTwoChildren = roomTwo.querySelector("[data-children]");

      const roomThree = document.querySelector("[data-room-three]");
      const roomThreeAdults = roomThree.querySelector("[data-adults]");
      const roomThreeChildren = roomThree.querySelector("[data-children]");

      const roomFour = document.querySelector("[data-room-four]");
      const roomFourAdults = roomFour.querySelector("[data-adults]");
      const roomFourChildren = roomFour.querySelector("[data-children]");

      if (selectedValue === "1") {
        roomOne.classList.remove("hidden");
        roomOneAdults.classList.add("is-active");
        roomOneChildren.classList.add("is-active");

        roomTwo.classList.add("hidden");
        roomTwoAdults.classList.remove("is-active");
        roomTwoChildren.classList.remove("is-active");

        roomThree.classList.add("hidden");
        roomThreeAdults.classList.remove("is-active");
        roomThreeChildren.classList.remove("is-active");

        roomFour.classList.add("hidden");
        roomFourAdults.classList.remove("is-active");
        roomFourChildren.classList.remove("is-active");
      } else if (selectedValue === "2") {
        roomOne.classList.remove("hidden");
        roomOneAdults.classList.add("is-active");
        roomOneChildren.classList.add("is-active");

        roomTwo.classList.remove("hidden");
        roomTwoAdults.classList.add("is-active");
        roomTwoChildren.classList.add("is-active");

        roomThree.classList.add("hidden");
        roomThreeAdults.classList.remove("is-active");
        roomThreeChildren.classList.remove("is-active");

        roomFour.classList.add("hidden");
        roomFourAdults.classList.remove("is-active");
        roomFourChildren.classList.remove("is-active");
      } else if (selectedValue === "3") {
        roomOne.classList.remove("hidden");
        roomOneAdults.classList.add("is-active");
        roomOneChildren.classList.add("is-active");

        roomTwo.classList.remove("hidden");
        roomTwoAdults.classList.add("is-active");
        roomTwoChildren.classList.add("is-active");

        roomThree.classList.remove("hidden");
        roomThreeAdults.classList.add("is-active");
        roomThreeChildren.classList.add("is-active");

        roomFour.classList.add("hidden");
        roomFourAdults.classList.remove("is-active");
        roomFourChildren.classList.remove("is-active");
      } else if (selectedValue === "4") {
        roomOne.classList.remove("hidden");
        roomOneAdults.classList.add("is-active");
        roomOneChildren.classList.add("is-active");

        roomTwo.classList.remove("hidden");
        roomTwoAdults.classList.add("is-active");
        roomTwoChildren.classList.add("is-active");

        roomThree.classList.remove("hidden");
        roomThreeAdults.classList.add("is-active");
        roomThreeChildren.classList.add("is-active");

        roomFour.classList.remove("hidden");
        roomFourAdults.classList.add("is-active");
        roomFourChildren.classList.add("is-active");
      }
    }

    selectElement.addEventListener("change", initChange);
  }
  // ROOMS CHANGE FUNCTION END

  changeRoomsRows();

  // --------------------------------------------- //

  const button = document.querySelector("[data-booking-button]");

  document.addEventListener("DOMContentLoaded", () => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      init();

      // const client =
      //   document.querySelector("[data-url-items]").dataset.urlClient;

      const language =
        document.querySelector("[data-url-items]").dataset.urlLanguage;

      const checkin =
        document.querySelector("[data-url-items]").dataset.urlCheckin;
      const checkout =
        document.querySelector("[data-url-items]").dataset.urlCheckout;
      const rooms = document.querySelector("[data-url-items]").dataset.urlRooms;
      const adults =
        document.querySelector("[data-url-items]").dataset.urlAdults;
      const children =
        document.querySelector("[data-url-items]").dataset.urlChildren;
      const code = document.querySelector("[data-url-items]").dataset.urlCode;

      button.dataset.bookingUrl = `https://hotelwebsitebooking.com/?client=pallas${language}${checkin}${checkout}${rooms}${adults}${children}${code}`;

      window.open(button.dataset.bookingUrl, "_blank");
    });
  });
}
